import { Divider, Stack, Typography } from "@mui/material"
import { Accordion } from "minimals-template/components/accordion"
import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ListItemBox } from "lib/@components/ListItemBox"
import { AISteps } from "routes/schedule/plugins/ai-steps/a-i-steps"
import Iconify from "minimals-template/components/Iconify"
import { LocalizedMessage } from "lib/localization/localized-message"
import { NotInPdf } from "lib/@components/pdf/not-in-pdf"

const DISCLAIMER_TEMPLATE =
    "This check list is a short summary of the task, it is not the SFG20 task. This summary may be used to remind individuals performing the task about the steps, but they must be familiar with the full schedule. They can access the full schedule by using the SFG20 app and the Smart Words associated with the task."

export function TaskSteps() {
    const [openDetails, setOpenDetails] = useState(false)
    const { schedule, task, schedulePath, currentId } = useBoundContext()
    return (
        schedule &&
        (schedulePath || currentId) && (
            <NotInPdf>
                <Divider sx={{ mt: 1 }} />
                <Accordion
                    open={openDetails}
                    onChange={setOpenDetails}
                    title={
                        <ListItemBox spacing={1}>
                            <Iconify icon="material-symbols:list-alt-check-outline-rounded" />
                            <Typography>
                                <LocalizedMessage template="Check List" />
                            </Typography>
                        </ListItemBox>
                    }
                >
                    <Stack spacing={2} sx={{ mt: 2, pl: 5, pr: 2 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 500 }}>
                            <LocalizedMessage template={DISCLAIMER_TEMPLATE} />
                        </Typography>
                        <AISteps schedule={schedule} task={task} />
                    </Stack>
                </Accordion>
            </NotInPdf>
        )
    )
}
